export enum LocalStorageKeys {
    currentRunningGameTab = 'cgp_CURRENT_RUNNING_GAME_TAB',
    currentRunningGameType = 'cgp_CURRENT_RUNNING_GAME_TYPE',
    uccMessages = 'cgp_ucc',
    crossBrandSpecificNavigationInfo = 'orbit_crossBrandSpecificNavigation',
    clientIpAddressesV2 = "orbit_clientIpAddressesV2",
    videoSlides = 'cgp_VideoSlides',
    lastLogin = "cgp_lastLogin",
    explorerMenuBadgeShown = 'cgp_EXPLORER_MENU_BADGE_SHOWN',
    realityCheckLastOccurrence = 'rc_occurrence',
    authorizedUserRestrictions = 'authorizedUserRestrictions',
    jackpotBetsOptInReminderStatus = 'jackpotBetsOptInReminderStatus',
    recentlyPlayedGames = 'recentlyPlayedGames',
    aiRegularGamesRecommendations = 'aiRegularGamesRecommendations',
    aiRecentlyAddedGamesRecommendations = 'aiRecentlyAddedGamesRecommendations',
    idleRecommendationsData = 'idleRecommendationsData',
    registrationStoredData = "cgp_storeRegistrationData",
    igcInitialTooltipShown = 'cgp_IGCInitialTooltip',
    igcLastShownCampaignExpiration = 'cgp_IGCLastShownCampaignExpiration'
}